// Help Components
export { default as HelpDocumentation } from './HelpDocumentation';
export { default as HelpButton } from './HelpButton';

// Help Context and Hooks
export { 
  HelpProvider, 
  useHelp, 
  useHelpContent,
  type HelpContent 
} from './HelpContext';

// Help Content Keys (for easy reference)
export const HELP_KEYS = {
  TASK_CREATION: 'task-creation',
  TASK_SEARCH: 'task-search',
  TASK_STATUS: 'task-status',
  TASK_EDITING: 'task-editing',
  TASK_COMMENTS: 'task-comments',
  TASK_ATTACHMENTS: 'task-attachments',
  TASK_DASHBOARD: 'task-dashboard',
  TASK_PRIORITY: 'task-priority',
  TASK_TIME_TRACKING: 'task-time-tracking',
} as const;
